import React, { useState } from 'react';
import { UserIcon, BuildingIcon, PhoneIcon, MailIcon, SaveIcon, XIcon, TagIcon, ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
export function ContactHeader({
  contact,
  isEditing,
  onSave,
  onCancel
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  const formatDate = dateString => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  };
  const getInitials = () => {
    if (contact.type === 'organization') {
      return contact.company.substring(0, 2).toUpperCase();
    }
    return `${contact.firstName.charAt(0)}${contact.lastName.charAt(0)}`;
  };
  const getFullName = () => {
    if (contact.type === 'organization') {
      return contact.company;
    }
    return `${contact.firstName} ${contact.lastName}`;
  };
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };
  return <div className="bg-white shadow-md rounded-lg p-4 md:p-6 m-4 md:m-6 mb-4" data-id="element-2">
      {isExpanded ? <>
          <div className="flex justify-end mb-2" data-id="element-3">
            <button onClick={toggleExpanded} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Collapse header" data-id="element-4">
              <ChevronUpIcon className="w-5 h-5" data-id="element-5" />
            </button>
          </div>
          <div className="flex flex-col md:flex-row items-start justify-between w-full" data-id="element-6">
            <div className="flex items-start gap-4" data-id="element-7">
              <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-full bg-blue-600 text-white flex items-center justify-center text-2xl font-bold" data-id="element-8">
                {getInitials()}
              </div>
              <div data-id="element-9">
                <h1 className="text-2xl md:text-3xl font-bold text-gray-800 flex items-center gap-2" data-id="element-10">
                  {contact.type === 'organization' ? <BuildingIcon className="w-6 h-6 text-gray-500" data-id="element-11" /> : <UserIcon className="w-6 h-6 text-gray-500" data-id="element-12" />}
                  {getFullName()}
                </h1>
                {contact.position && contact.company && contact.type === 'person' && <p className="text-gray-600 mt-1" data-id="element-13">
                      {contact.position} at {contact.company}
                    </p>}
              </div>
            </div>
            <div className="flex flex-col items-end mt-4 md:mt-0" data-id="element-14">
              <div className="flex items-center gap-2 text-gray-600 justify-end" data-id="element-15">
                <a href={`mailto:${contact.email}`} className="hover:text-blue-600 text-right" data-id="element-16">
                  {contact.email}
                </a>
                <MailIcon className="w-4 h-4" data-id="element-17" />
              </div>
              <div className="flex items-center gap-2 text-gray-600 mt-2 justify-end" data-id="element-18">
                <a href={`tel:${contact.phone}`} className="hover:text-blue-600 text-right" data-id="element-19">
                  {contact.phone}
                </a>
                <PhoneIcon className="w-4 h-4" data-id="element-20" />
              </div>
            </div>
          </div>
          {isEditing && <div className="flex justify-end mt-4" data-id="element-21">
              <div className="flex gap-2" data-id="element-22">
                <button onClick={() => onSave({})} className="flex items-center gap-1 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors" data-id="element-23">
                  <SaveIcon className="w-4 h-4" data-id="element-24" />
                  <span data-id="element-25">Save</span>
                </button>
                <button onClick={onCancel} className="flex items-center gap-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors" data-id="element-26">
                  <XIcon className="w-4 h-4" data-id="element-27" />
                  <span data-id="element-28">Cancel</span>
                </button>
              </div>
            </div>}
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-29">
            <div className="flex flex-wrap gap-3 items-center" data-id="element-30">
              <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-31">
                <TagIcon className="w-4 h-4 text-gray-400" data-id="element-32" />
                {contact.tags.map((tag, index) => <span key={index} className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs" data-id="element-33">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>
        </> : <div className="flex items-center justify-between" data-id="element-34">
          <div className="flex items-center gap-2" data-id="element-35">
            <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center text-sm font-bold" data-id="element-36">
              {getInitials()}
            </div>
            <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2" data-id="element-37">
              {contact.type === 'organization' ? <BuildingIcon className="w-5 h-5 text-gray-500" data-id="element-38" /> : <UserIcon className="w-5 h-5 text-gray-500" data-id="element-39" />}
              {getFullName()}
            </h1>
          </div>
          <button onClick={toggleExpanded} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Expand header" data-id="element-40">
            <ChevronDownIcon className="w-5 h-5" data-id="element-41" />
          </button>
        </div>}
    </div>;
}